/**
 * Check if Int32 value is positive
 *
 * @param {import('./Int32Type.js').BrandedInt32} value - Value
 * @returns {boolean} True if positive
 */
export function isPositive(value) {
	return value > 0;
}
